<template>
  <div>
        <Form layout="inline" :form="search" class="form">

        <div class="floor1">
          <FormItem class="content">
            <span class="label_text content_text">内容</span>
            <div class="input_icon_box">
              <div id="title" name="title" @focus="(searchContentCombindList.length<1) ? focusDiv : '' " @blur="blurDiv" tabindex="0" hidefocus="true" class="content_input input" @click.stop="clcikContent" @change="getCondition">
                <!-- <div class="control_scroll"> -->
                  <div class="each_content_box">
                    <span class="placeholder_text" v-show="isClickInpFlag">搜索License ID、项目名称、申请工单号、申请人、最终客户</span>
                    <div class="search_content" v-if="showSearchFlag">
                      <div class="each_content" v-for="(item,index) in searchContentCombindList" :key="index">
                        <span class="each_text" @click="getCurrent(item,index)">{{item.combindedBlock}}</span>
                        <span class="delete_icon" @click="removeInCombind(item,index)"></span>
                      </div>
                    </div>
                    <div class="search_content" v-if="!showSearchFlag&&searchContentCombindList.length">
                      <span class="search_text">{{ setSearchText() }}</span>
                    </div>
                  </div>
              </div>
              <div class="search_icon" @click="searchByCurrentContent">
                <!-- <a-icon type="search" class="ant_design_icon" /> -->
              </div>
              <div :style="{top: modelTop}" class="multi_function_search_box" v-if="showSearchFlag" v-clickoutside="handleFunction">
                <SelectSearch @transferCombinedContent="getCombinedData"></SelectSearch>
              </div>
            </div>
            <!-- <div class="multi_function_search_box" v-if="showSearchFlag" v-clickoutside="handleFunction">
              <SelectSearch @transferCombinedContent="getCombinedData" @transferClickType="getClickType" @transferClickKey="getClickKey"></SelectSearch>
            </div> -->
          </FormItem>
          <FormItem class="version">
            <span class="label_text">License版本</span>
                  <a-select :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}" style="width: 136px" :dropdownMatchSelectWidth=false dropdownClassName="version_dropdown"  option-label-prop="label" default-value="-1"  @change="chooseVersion">
                      <!-- <a-select-option value="all">全部</a-select-option>
                      <a-select-option value="最新统一版">最新统一版</a-select-option>
                      <a-select-option value="较新版Server">较新版Server（v7.2以下）</a-select-option>
                      <a-select-option value="旧版Server">旧版Server（v6.3.1以下）</a-select-option>
                      <a-select-option value="旧版Browser">旧版Browser（v6.3.1以下）</a-select-option>
                      <a-select-option value="旧版SDK">旧版SDK（v5.13以下）</a-select-option> -->
                      <a-select-option v-for="(item,index) in versionSelectList" :key="index" :label="item.title" :value="item.type">
                        <div class="version_item" >
                          <p class="title">{{item.title}}</p>
                          <p class="desc">{{item.desc}}</p>
                        </div>
                      </a-select-option>
                  </a-select>
                <!-- <div class="version_select_box">
                  <div class="version_title">License_V2.0</div>
                  <div class="version_desc">适用于Server v7.2，Browser v4.2，SDK v5.13，DataView v1.0版本及以上</div>
                </div> -->
          </FormItem>
          <FormItem class="product">
            <span  class="label_text">包含产品</span>
            <a-select style="width: 120px" default-value="0"   @change="chooseContainProduct"  :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
              <a-select-option value="0">全部</a-select-option>
              <a-select-option v-for="(item,index) in products" :key="index" :label="item.productName" :value="item.productId">
                {{item.productName}}
              </a-select-option>
            </a-select>
          </FormItem>
        </div>
        <div class="floor2">
          <FormItem class="status">
            <span  class="label_text">状态</span>
              <a-select style="width: 120px;" default-value="-1"  @change="chooseStatus"  :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}" >
                <a-select-option value="-1">全部</a-select-option>
                <a-select-option value="0">未激活</a-select-option>
                <a-select-option value="1">已激活</a-select-option>
              </a-select>
          </FormItem>
          <FormItem class="allpyTime">
            <span  class="label_text apply">申请时间</span>
            <!-- <a-date-picker style="width: 336px;"  @change="chooseApplyTime" placeholder="请选择申请时间">
                <a-icon slot="suffixIcon" type="calendar" />
              </a-date-picker> -->
              <a-range-picker
                :show-time="{ format: 'HH:mm' }"
                format="YYYY-MM-DD HH:mm"
                :disabled-date="disabledDate"
                :disabled-time="disabledRangeTime"
                :placeholder="['开始时间', '结束时间']"
                separator="→"
                @change="chooseApplyTime"
                @ok="applyTimeOk"
                style="width: 336px;"
                :getCalendarContainer="getCalendarContainer()"
              >
                <a-icon slot="suffixIcon" type="calendar" />
              </a-range-picker>
          </FormItem>
          <FormItem class="affctiveTime">
            <span  class="label_text affective">生效时间</span>
            <!-- <a-date-picker style="width: 338px;"  @change="chooseAffectiveTime" placeholder="请选择申请时间">
                <a-icon slot="suffixIcon" type="calendar" />
              </a-date-picker> -->
              <a-range-picker
                :show-time="{ format: 'HH:mm' }"
                format="YYYY-MM-DD HH:mm"
                :disabled-date="disabledDate"
                :placeholder="['开始时间', '结束时间']"
                @change="chooseAffectiveTime"
                @ok="AffectiveTimeOk"
                separator="→"
                style="width: 339px;"
                :getCalendarContainer="getCalendarContainer()"
              >
                <a-icon slot="suffixIcon" type="calendar" />
              </a-range-picker>
          </FormItem>
        </div>
      </Form>
  </div>
</template>

<script>
import { Table, Form, Input, Button,Select, DatePicker, Icon, Result,Modal } from 'ant-design-vue'
const { Item: FormItem } = Form
import moment from 'moment'
import './filterCondition.less'

import SelectSearch from "@/components/selectSearch/selectSearch.vue"
// import ClickOutSide from 'vue-v-clickoutside'
import clickoutside from '../../../directives/clickOutside.js'
import vuescroll from 'vuescroll';
import { createNamespacedHelpers } from 'vuex'
const { mapActions,mapState,mapMutations } = createNamespacedHelpers('manage')


export default {
  data () {
    return {
      modelTop: "40px",
      search: {
        user: '',
      },
      domObj: null,
      versionSelectList:[
        {
          title:"全部",
          desc:"",
          type:"-1"
        },
        {
          title:"License_V2.2",
          desc:"",
          type:"6"
        },
        {
          title:"License_V2.1",
          desc:"",
          type:"5"
        },
        {
          title:"License_V2.0",
          desc:"适用于Server v7.2，Browser v4.2，SDK v5.13，DataView v1.0，APP v3.0，小程序 v2.0 版本及以上",
          type:"0"
        },
        {
          title:"License_V1.0",
          desc:"适用于Server v6.3.1及以上，v7.2以下",
          type:"1"
        },
        {
          title:"License_V1.1",
          desc:"适用于Server v1.0及以上，v6.3.1以下",
          type:"2"
        },
        {
          title:"License_V1.2",
          desc:"适用于SDK v1.0及以上，v5.13以下",
          type:"3"
        },
        {
          title:"License_V1.3",
          desc:"适用于Browser v1.0及以上，v4.2以下",
          type:"4"
        },
      ],
      form: this.$form.createForm(this, { name: 'license' }),
      version:"",
      data:[],
      showSearchFlag:false,
      searchContentCombindList:[],
      clickId:"",
      detailmodalVisible: false, // 默认不展示详情弹窗
      updateEmailModalVisible:false, // 默认不展示邮箱弹窗
      email:"",
      emailTipsFlag:false, // 默认不展示邮箱错误提示
      IdParamsArr:[],
      projectNameParamsArr:[],
      orderNoParamsArr:[],
      applicantNameParamsArr:[],
      customerNameParamsArr:[],
      isClickInpFlag:true, // 默认显示placeholder
    }
  },
  created(){
    // 默认清空所有上次遗留条件
    this.resetAllcondition()
  },
  mounted(){
  },
  computed:{
    ...mapState(['condition','isClickTypeFlag', 'products']),
  },
  methods:{
    ...mapActions(['queryDataInType','getTableData', 'getProducts']),
    ...mapMutations(['changeVersion','updateSelectCondition','alreadyClickType','updateTotal']),
    setSearchText () {
      if(this.searchContentCombindList.length){
        let arr = []
        this.searchContentCombindList.forEach(item => {
          arr.push(item.combindedBlock)
        })
        return arr.join('，')
      }
      return ''
    },
    getCalendarContainer() {
      return triggerNode => triggerNode.parentNode;
    },
    // 重置所有条件
    resetAllcondition(){
      this.updateSelectCondition({
        activeTimeFrom: "",
        activeTimeTo: "",
        applicantName: "",
        applyTimeFrom: "",
        customerName: "",
        applyTimeTo: "",
        licenseId: "",
        orderNo: "",
        pageNo: 1,
        productType: 0,
        projectName: "",
        sortName: "createTime",
        sortOrder: "desc",
        status: -1,
        versionType: -1,
        pageSize: 20,
      })
    },
    // 更新
    async updateTable(){
      let params = this.condition
      await this.getTableData(params).then(result=>{
        if(result==undefined){
          this.updateTotal(0)
        }
      });
    },
    // 选择版本
    chooseVersion(value){
        this.updateSelectCondition({pageNo:1})
        this.changeVersion(value);
        // this.changeVersion({versionType:value})
        this.updateTable();
    },
    // 包含的产品
    chooseContainProduct(event){
      this.updateSelectCondition({productType:event,pageNo:1})
      this.updateTable();
    },
    chooseStatus(value){
      this.updateSelectCondition({status:value,pageNo:1})
      this.updateTable();
    },
    range(start, end) {
      const result = []
      for (let i = start; i < end; i++) {
        result.push(i)
      }
      return result
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current < moment('2001') || current > moment().endOf('day')
    },
    chooseApplyTime(date, dateString){
      // this.applyTime =dateString;
      if(dateString[0]==""&&dateString[1]==""){
        //
        this.updateSelectCondition({applyTimeFrom:dateString[0],applyTimeTo:dateString[1],pageNo:1})
        this.updateTable();
      }
      else{
          this.applyStart = dateString[0]
          this.applyEnd = dateString[1]
      }
    },
    disabledRangeTime(_, type) {
      // let start = moment().calendar().substring(2).split(':')
      //  let choosedDay= this.applyStart
      if(this.applyStart){
        var choosedDay = this.applyStart.substr(8,2);
        let choosedHour =  this.applyStart.substr(11,2);
        let choosedMinute = this.applyStart.substr(14,2);
        var currentDay = new Date().getDate()
        var curentHour=new Date().getHours();
        var currentMinute = new Date().getMinutes();
      }
      if (type === 'end') {
        // 是今天，起点  则未来时分不可选
        if(choosedDay == currentDay){
          return {
            disabledHours: () =>
              this.range(0, 24).splice(curentHour+1,24),
            disabledMinutes: () =>
              this.range(0, 60).splice(currentMinute+1,60)
          }
        }else{
          return {
            disabledHours: () =>
              this.range(0, 24).splice(0,0),
            disabledMinutes: () =>
              this.range(0, 60).splice(0,0)
          }
        }
      }else{
          // start
          if(choosedDay == currentDay){
            return {
              disabledHours: () =>
                this.range(0, 24).splice(curentHour+1,24),
              disabledMinutes: () =>
                this.range(0, 60).splice(currentMinute+1,60)
            }
          }else{
            return {
              disabledHours: () =>
                this.range(0, 24).splice(0,0),
              disabledMinutes: () =>
                this.range(0, 60).splice(0,0)
            }
          }
        }
  },
    applyTimeOk(value) {
      //
      let applyStart = value[0]._d;
      //  let applyStart = value[0]._d;
      let applyEnd = value[1]._d;
    //  if(applyStart!=""&&applyEnd!=""){
      this.updateSelectCondition({applyTimeFrom:this.applyStart,applyTimeTo: this.applyEnd})
      this.updateTable();
    //  }
    },
    chooseAffectiveTime(date,dateString){
      if(dateString[0]==""&&dateString[1]==""){
        this.updateSelectCondition({activeTimeFrom:dateString[0],activeTimeTo:dateString[1],pageNo:1})
        this.updateTable();
      }
      else{
        this.effectStart = dateString[0]
        this.effectEnd = dateString[1]
      }
    },
    AffectiveTimeOk(value){
      let effectStart =  value[0]._d;
      let effectEnd = value[1]._d;
      this.updateSelectCondition({activeTimeFrom:this.effectStart,activeTimeTo:this.effectEnd})
      this.updateTable();
    },
    // 得到检索内容
    getCondition(event){
    },
    // 得到检索结合块
    getCombinedData(choosedCombindArr){
      if(this.searchContentCombindList.length < 5){
        if(this.searchContentCombindList.some(item => item.combindedBlock === choosedCombindArr.combindedBlock)){
          return
        }
        this.searchContentCombindList.push(choosedCombindArr)
      }else{
        this.$message.warning('仅可选项5项', 1)
      }
      if(this.searchContentCombindList.length){
        this.isClickInpFlag=false
      }
    },
    getCurrent(item,index){

    },
    removeInCombind(item,index){
      this.searchContentCombindList.splice(index,1)
      this.updateSelectCondition({licenseId:"",projectName:"",orderNo:"",applicantName:"",customerName:""})
      // 清空多功能搜索框的参数队列
      this.IdParamsArr=[]
      this.projectNameParamsArr=[]
      this.orderNoParamsArr=[]
      this.applicantNameParamsArr=[]
      this.customerNameParamsArr=[]
      // this.getTableData()
    },
    // 多功能手动检索 刷新表格
    searchByCurrentContent(){
      // 清空多功能搜索框的参数队列
      this.IdParamsArr=[]
      this.projectNameParamsArr=[]
      this.orderNoParamsArr=[]
      this.applicantNameParamsArr=[]
      this.customerNameParamsArr=[]
      if(this.searchContentCombindList.length<1){
        this.updateSelectCondition({pageNo:1})
        this.updateTable();
      } else {
        this.searchContentCombindList.forEach(item=>{
            if(item.params=="licenseId"){
              this.IdParamsArr.push(item.paramsValue)
              if(this.IdParamsArr.length<=1){
                this.updateSelectCondition({licenseId:this.IdParamsArr.join(""),pageNo:1})
              } else {
                this.updateSelectCondition({licenseId:this.IdParamsArr.join(","),pageNo:1})
              }
            }
            if(item.params=="projectName"){
              this.projectNameParamsArr.push(item.paramsValue)
              if(this.projectNameParamsArr.length<=1){
                this.updateSelectCondition({projectName:this.projectNameParamsArr.join(""),pageNo:1})
              } else {
                this.updateSelectCondition({projectName:this.projectNameParamsArr.join(","),pageNo:1})
              }
            }
            if(item.params=="orderNo"){
              this.orderNoParamsArr.push(item.paramsValue)
              if(this.orderNoParamsArr.length<=1){
                this.updateSelectCondition({orderNo:this.orderNoParamsArr.join(""),pageNo:1})
              } else {
                this.updateSelectCondition({orderNo:this.orderNoParamsArr.join(","),pageNo:1})
              }
            }
            if(item.params=="applicantName"){
              this.applicantNameParamsArr.push(item.paramsValue)
              if(this.applicantNameParamsArr.length<=1){
                this.updateSelectCondition({applicantName:this.applicantNameParamsArr.join(""),pageNo:1})
              } else {
                this.updateSelectCondition({applicantName:this.applicantNameParamsArr.join(","),pageNo:1})
              }
            }
            if(item.params=="customerName"){
              this.customerNameParamsArr.push(item.paramsValue)
              if(this.customerNameParamsArr.length<=1){
                this.updateSelectCondition({customerName:this.customerNameParamsArr.join(""),pageNo:1})
              } else {
                this.updateSelectCondition({customerName:this.customerNameParamsArr.join(","),pageNo:1})
              }
            }
          })
          this.updateTable();
        }
    },
    // 点击检索输入框
    clcikContent(){
      // this.showSearchFlag=true
        this.showSearchFlag=true
    },
    focusDiv(){
      // 聚焦消失placeholder
      this.isClickInpFlag=false
    },
    blurDiv(){
      if(this.searchContentCombindList.length){
        this.isClickInpFlag=false
      }
      else{
        this.isClickInpFlag=true
      }
    },
    // 滚轮
    // 初始化与绑定监听事件方法
    // 点击搜索组件以外区域 关闭
    handleFunction(){
      this.showSearchFlag=false;
    },
  },
  watch:{
      searchContentCombindList(newValue, oldValue){
      if(newValue.length<1){
          this.isClickInpFlag=true
      }
      if (newValue.length<3) {
        this.modelTop = '40px'
      } else if (newValue.length<5) {
        this.modelTop = '72px'
      } else {
        this.modelTop = '104px'
      }
      // 更新表格
      this.searchByCurrentContent()
    }
  },
  components:{
    SelectSearch,
    Table,
    Form,
    FormItem,
    Ainput: Input,
    Button,
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-date-picker": DatePicker,
    "a-range-picker": DatePicker.RangePicker,
    "a-icon": Icon,
    "a-modal": Modal,
    "a-button": Button,
  },
  directives: {
    clickoutside
  }
}
</script>

<style lang="less" scoped>
.search_text{
  vertical-align: middle;
  display: inline-block;
  max-width: 100%;
  background: #e6f4ff;
  font-size: 12px;
  line-height: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4e4e4e;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: normal;
  white-space: nowrap;
}
</style>
